module.exports = __webpack_public_path__ + "assets/gluten_free-b9db8c.svg";